import { PropertyConfig } from "../../../forms/propertyConfig";
import { anyReallyAny } from "../../../tools/object.tools";
import { RegisterValidator, Validator } from "./validator";

/**
 * This validator ensures the value is >= a specific value
 * sample use in propertyConfig => validators: validatorEntry(MinValueValidator, 15) or validators: { minValue: 15 } (second option requires this class to be loaded)
 */
@RegisterValidator("minValue")
export class MinValueValidator implements Validator<number, number> {

    /**
     * @returns true if propertyValue is >= minValue
     */
    public isValid(property: PropertyConfig, propertyValue: number, minValue: number, allProperties: Record<string, PropertyConfig>, allPropertiesValue: Record<string, unknown>): boolean {
        if (propertyValue == null || propertyValue as anyReallyAny === "") {
            // If value is empty/null/undefined, the validation is not applied (it is RequiredValidator's job)
            return true;
        }
        return propertyValue >= minValue;
    }
}